module.exports = __webpack_public_path__ + "img/1 (29).50841d5d.png";